import '../styles/adminContactStyles.css'
import ContactRightPanel from './ContactRightPanel';
import SubscriptionsSection from './SubscriptionsSection';
import { updateSubscriptions } from '../service/adminContact_service';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getInitialAccessTemplate } from '../service/adminContact_service';
import { sendInitialAccessMail } from '../service/adminContact_service';
import SingleSelectDropdown from '../../../shared/components/SingleSelectDropdown';
import calenderIcon from '../../../assets/images/calendar.svg'


const GeneralInfoTab = ({
  selectedContact
}) => {

  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [contactDetails, setContactDetails] = useState(selectedContact || null);
  const [showEmailDialouge, setShowEmailDialouge] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const [initialAccessTemplates, setInitialAccessTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isCC, setIsCC] = useState(false)

  const handleEmailToContact = async () => {
  

  const response = await getInitialAccessTemplate();

  const templates = response.data.filter(t => [2, 6, 8].includes(t.templateTypeID));
  setInitialAccessTemplates(templates)

  const defaultTemplate = templates.find(t => t.templateTypeID === 6);
  setSelectedTemplate(defaultTemplate)

  
  setShowEmailDialouge(true);
};

useEffect(()=>{
  if (!selectedTemplate) return;

  let template = selectedTemplate.emailTemplate;
  const {firstName,lastName} = getNameParts(contactDetails.webUserName);
  const email = contactDetails.email;
  const salutation = contactDetails.salutation || firstName;

  template = template
    ?.replace("&lt;&lt;FirstName&gt;&gt;", firstName)
  ?.replace("&lt;&lt;UserName&gt;&gt;", email)
  ?.replace("&lt;&lt;Salutation&gt;&gt;", salutation);

  setPreviewHtml(template);
},[selectedTemplate])

  useEffect(() => {
  const showemaildialouge = location.state?.showEmailDialouge;

  if (!showemaildialouge) return;

  handleEmailToContact();

  // clear navigation state so it won't trigger again
  navigate(".", { replace: true, state: {} });

}, [location.state, navigate]);
  
  const formatDateInput = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };
  const getNameParts = (fullName) => {
  if (!fullName) {
    return { firstName: "", lastName: "" };
  }

  const parts = fullName.trim().split(/\s+/);

  return {
    firstName: parts[0] || "",
    lastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
  };
};

const { firstName, lastName } = getNameParts(contactDetails.webUserName);

  const categories = [{categoryId: 1,categoryName: "Investor"}];
  const webStatuses = [
    {webStatusId: 1,webStatusName: "Active"},
    {webStatusId: 2,webStatusName: "InActive"},
    {webStatusId: 3,webStatusName: "Pending Invite"},
    {webStatusId: 4,webStatusName: "Pending Login"}
  ]

  const handleSaveSubscriptions = async() => {
    try{
      const payload = {
          "isDuoActivated": contactDetails.isDuoActivated,
          "isNotificationSubscribed":contactDetails.isDocEmail,
          "contactId": params.contactId,
          "isEmailDistribution": contactDetails.isEmailDistribution,
          "isPaperDistribution": contactDetails.isPaperDistribution,
          "isManagerCommentary": contactDetails.isManagerCommentary,
          "isBillingInvoiceNotification": contactDetails.isBillingInvoiceNotification,
          "isTaxDocumentsNotification" : contactDetails.isTaxDocumentsNotification,
      }

      await updateSubscriptions(payload);
      toast.success('Contact updated successfully')
      navigate('/AdminContact')
    }
    catch{
      toast.success('Contact update failed')
    }
  }

  const sendMail = async () => {
    if(selectedTemplate.templateTypeID === 6 && contactDetails.webStatusName === "Active")
      {
        toast.error('The user is already active')
        return
      }
    try{
      const payload = {
      "email": contactDetails.email,
      "isCC": isCC,
      "templateType": parseInt(selectedTemplate.templateTypeID),
      "isForgotPasswordFlow": true,
      "isNotificationSubscribed" : contactDetails.isDocEmail,
      "isManagerCommentary" : contactDetails.isManagerCommentary,
      "isTaxDocumentsNotification" : contactDetails.isTaxDocumentsNotification,
      "contactId": contactDetails.webUserId,
      "webStatusId": contactDetails.webStatusId,
      "status":contactDetails.webStatusName === "Active" ? true: false
  };

  await sendInitialAccessMail(payload)
  toast.success('Mail sent to contact successfully')
    }
    catch{
      toast.error('Unable to send mail to contact')
    }
  };


  return (
    <div className="admin-contact-wrapper">

      <div className="row form-horizontal" style={{ marginLeft: 0, marginRight: 0 }}>

        {!showEmailDialouge && 
        <>
        {/* LEFT COLUMN */}
        <div className="col-sm-4">

          <div className="form-group">
            <label className="col-sm-4 control-label text-right">
              *Contact Category:
            </label>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={contactDetails.categoryId || ""}
                onChange={()=> {}}
                disabled
              >
                <option value="">Select</option>
                {categories.map(c => (
                  <option key={c.categoryId} value={c.categoryId}>
                    {c.categoryName}
              
                  </option>
                ))}
              </select>
            </div>
          </div>

          {[
            ["*Web User ID:", contactDetails.email],
            ["*Email:", contactDetails.email],
            ["*First Name:", firstName],
            ["*Last Name:", lastName],
            ["Salutation:", contactDetails?.salutation || ""],
            ["Company:", contactDetails.companyName]
          ].map(([label, value], i) => (
            <div className="form-group" key={i}>
              <label className="col-sm-4 control-label text-right">
                {label}
              </label>
              <div className="col-sm-7">
                <input
                  className="form-control"
                  value={value || ""}
                  readOnly
                />
              </div>
            </div>
          ))}

        </div>


        {/* MIDDLE COLUMN */}
        <div className="col-sm-5">

          <div className="form-group">
            <label className="col-sm-4 control-label text-right">
              *Web Status:
            </label>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={contactDetails.webStatusId || ""}
                onChange={()=> {}}
                disabled={true}
              >
                <option value="" >Select</option>
                {webStatuses.map(s => (
                  <option key={s.webStatusId} value={s.webStatusId}>
                    {s.webStatusName}
                  </option>
                ))}
              </select>
            </div>
            </div><div className="form-group">
              <label className="col-sm-4 control-label text-right">
                Deactivate Date:
              </label>

              <div className="col-sm-4">
                <div style={{ position: "relative" }}>

                  <input
                    className="form-control"
                    style={{ paddingRight: "25px" }}
                    value={formatDateInput(contactDetails.deactivateDate)}
                    readOnly
                  />

                  <img
                    src={calenderIcon}
                    alt="calendar"
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "14px",
                      height: "14px",
                      opacity: 0.7,
                      pointerEvents: "none"
                    }}
                  />

                </div>
              </div>
            </div>

          <div className="form-group">
            <label className="col-sm-4 control-label text-right">
              Password Expires After:
            </label>
            <div className="col-sm-3">
              <input
                className="form-control"
                value={contactDetails.passwordExpireDays || ""}
                readOnly
              />
            </div>
            <div className="col-sm-1 days-label">
              Days
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label text-right">
              Phone:
            </label>
            <div className="col-sm-7">
              <input
                type="tel"
                className="form-control"
                value={contactDetails.phone || ""}
                readOnly
              />
            </div>
          </div>

          {/* SUBSCRIPTIONS */}
          <SubscriptionsSection selectedContact={contactDetails} setContactDetails={setContactDetails}/>

        </div>
        </>
        }
        {showEmailDialouge && 
        <>
        <div className="col-sm-9">

    <div>
      <label>
        Do you want to send an email to contact with login information?
      </label>
    </div>

    <div style={{ textAlign: "center", display:'flex', gap: '10px' }}>
      <button
        className="btn btn-primary"
        onClick={() => setShowEmailDialouge(false)}
      >
        No
      </button>

      <button
        className="btn btn-primary"
        onClick={sendMail}
      >
        Send
      </button>
    </div>

    <div style={{ marginTop: 10 }}>

  <label>
    <input
      type="checkbox"
      checked={isCC}
      onChange={() => setIsCC((prev)=>!prev)}
    />

    Send a copy to <span>mbowen@beatriceadvisors.com</span>
  </label>

  <div style={{ marginTop: 10, width: '20%' }}>
    <SingleSelectDropdown
    options={initialAccessTemplates}
    selectedValue={selectedTemplate}
    onChange={(value) =>
      setSelectedTemplate(value)
     }
    textField="templateTypeName"
    valueField="templateTypeID"
    />
  </div>

</div>

    <div style={{ marginTop: "20px" }}>
      <div
        style={{ border: "1px solid black", padding: "15px" }}
        dangerouslySetInnerHTML={{ __html: previewHtml }}
      />
    </div>

  </div>
        </>}

        {/* RIGHT PANEL */}
        <ContactRightPanel selectedContact={contactDetails} setContactDetails={setContactDetails}/>
        

      </div>

      {/* SAVE BUTTON */}
      <div className="row save-row">
        <div className="col-sm-12 text-right">
          <button
            className="btn btn-primary btnPrimary"
            onClick={handleSaveSubscriptions}
          >
            Save
          </button>
        </div>
      </div>

    </div>
  );
};

export default GeneralInfoTab;